// SectionReveal.js
import { motion } from "framer-motion";

const SectionReveal = ({ children, delay = 0 }) => {
  return (
    <motion.div
      initial={{ clipPath: "polygon(50% 0%, 100% 0, 100% 100%, 0 100%, 0 0)" }}
      whileInView={{ clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)" }}
      transition={{ duration: 1.2, ease: "easeInOut", delay }}
      viewport={{ once: true, amount: 0.2 }} // 👈 important: trigger hone ke liye
      className="overflow-hidden"
    >
      {children}
    </motion.div>
  );
};

export default SectionReveal;
